var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 97,
    viewBox: "0 0 78 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4675 63.9763V58.8706H60.8682C64.6812 52.0736 66.6472 44.3926 66.5697 36.5954C66.5697 16.3836 54.2265 0 38.9992 0C23.772 0 11.4303 16.3867 11.4303 36.5984C11.3533 44.3946 13.3193 52.0745 17.1318 58.8706H29.5325V63.9732C15.5316 65.9457 4.31323 72.1802 0 80.2461C5.02968 85.5402 11.0801 89.755 17.7841 92.635C24.4881 95.515 31.706 97 39 97C46.294 97 53.5119 95.515 60.2159 92.635C66.9199 89.755 72.9703 85.5402 78 80.2461C73.6868 72.1833 62.4654 65.9457 48.4675 63.9763Z",
    fill: "#3E809D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMom);
export default __webpack_public_path__ + "static/media/mom.b25193e156999034caa2755704c8072d.svg";
export { ForwardRef as ReactComponent };